module.exports = __webpack_public_path__ + "files/afacb0f9697976ab91966f54a5002bfd.png";